<div>
    <mat-label class="font-size-body-text color-dark-blue">{{question.question.caption}} </mat-label>
</div>

